/* AETHEL — apariciones al bajar y paralaje de las palabras fantasma */
(() => {
  if (window.__aeInit) return;
  window.__aeInit = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let io;

  function observar(root = document) {
    const items = root.querySelectorAll('.ae-rev:not(.is-in), .ae-escribe:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    if (!io) {
      io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            if (e.target.__aeHijos) e.target.__aeHijos.forEach((h) => h.classList.add('is-in'));
            if (e.target.matches('.ae-rev, .ae-escribe')) e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    items.forEach((el) => {
      if (el.classList.contains('ae-escribe') && el.parentElement) {
        el.parentElement.__aeHijos = (el.parentElement.__aeHijos || []).concat(el);
        io.observe(el.parentElement);
      } else io.observe(el);
    });
  }

  // Paralaje: [data-ae-paralaje="0.25"] se desplaza más despacio que la página
  let paralajes = [];
  function recogerParalajes() {
    paralajes = Array.from(document.querySelectorAll('[data-ae-paralaje]'));
  }
  let ticking = false;
  function pintarParalaje() {
    ticking = false;
    const vh = window.innerHeight;
    paralajes.forEach((el) => {
      const sec = el.closest('.ae-sec') || el.parentElement;
      const r = sec.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const v = parseFloat(el.dataset.aeParalaje) || 0.2;
      const centro = r.top + r.height / 2 - vh / 2;
      el.style.transform = `translate3d(0, ${(-centro * v).toFixed(1)}px, 0)`;
    });
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(pintarParalaje); }
  }

  // "Dame otra": baraja de frases [data-ae-baraja] con su lista en un <template>
  function barajas(root) {
    root.querySelectorAll('[data-ae-baraja]:not([data-ae-listo])').forEach((caja) => {
      caja.dataset.aeListo = '1';
      const lista = (caja.querySelector('template')?.content.textContent || '')
        .split('\n').map((l) => l.trim()).filter(Boolean);
      const txt = caja.querySelector('[data-ae-baraja-texto]');
      const num = caja.querySelector('[data-ae-baraja-num]');
      const btn = caja.querySelector('[data-ae-baraja-boton]');
      if (!lista.length || !txt || !btn) return;
      let i = 0;
      const pintar = (animar) => {
        txt.textContent = lista[i];
        if (num) num.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(lista.length).padStart(2, '0');
        if (animar && !reduce) {
          txt.style.transition = 'none';
          txt.style.transitionDelay = '0s';
          txt.classList.remove('is-in');
          void txt.offsetWidth;
          txt.style.transition = '';
          txt.classList.add('is-in');
        }
      };
      btn.addEventListener('click', () => {
        let n = i;
        if (lista.length > 1) while (n === i) n = Math.floor(Math.random() * lista.length);
        i = n;
        pintar(true);
      });
      pintar(false);
    });
  }

  // Reloj en vivo [data-ae-reloj] (hora local del visitante)
  const relojes = new Set();
  function pintarRelojes() {
    const h = new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    relojes.forEach((el) => { el.textContent = h; });
  }
  function relojesInit(root) {
    root.querySelectorAll('[data-ae-reloj]').forEach((el) => relojes.add(el));
    pintarRelojes();
  }
  setInterval(pintarRelojes, 15000);

  function init(root) {
    observar(root);
    barajas(root);
    relojesInit(root);
    if (!reduce) { recogerParalajes(); pintarParalaje(); }
  }

  init(document);
  if (!reduce) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
